// extracted by mini-css-extract-plugin
module.exports = {"cardSliderModule":"cardmsgE_cardSliderModule__Jf6a6"};